import { isNumber, isString, isObject } from 'lodash';
import api from '@/modules/file/api';
import config from '@/modules/file/config';

/**
 * FileUpload
 *
 * @mixin
 */
export default {
  data() {
    return {
      openFileUpload: false,
      selectedFile: null,
    };
  },
  props: {
    allowSearcher: {
      type: Boolean,
    },
    label: {
      type: String,
      default: null,
    },
    titleLength: {
      type: [Number],
      default: 0,
    },
    filters: {
      type: Object,
    },
    value: {
      type: [Array, Object, Number, String],
    },
    size: {
      type: Number,
    },
    returnObject: Boolean,
  },
  computed: {
    fileType() {
      if (isObject(this.filters)
        && this.filters.type) {
        return this.filters.type;
      }
      // Default file type
      return 'binaryFile';
    },
    hasFile() {
      return this.selectedFile ? this.selectedFile : false;
    },
    processedFilters() {
      return {
        mimeType: this.mimeType,
        ...this.filters,
      };
    },
    mimeType() {
      return this.filters && this.filters.mimeType ? this.filters.mimeType : '*';
    },
  },
  methods: {
    iconFromExtension(extension) {
      return config.iconFromExtension(extension);
    },
    async clear() {
      this.selectedFile = null;
      this.$emit('input', null);
    },
    normalizeSelectorValue(value) {
      return value ? value.id : null;
    },
    getEmitValue(value) {
      return this.returnObject ? value : this.normalizeSelectorValue(value);
    },
    /** BEGIN - File selector methods * */
    fileSelected(file) {
      if (!file) {
        return this.clear();
      }
      this.selectedFile = file;
      return this.$emit('input', this.getEmitValue(file), file);
    },
    /** END - Content selector methods * */
    /** BEGIN - File wizard methods * */
    openFileUploadDialog() {
      this.openFileUpload = true;
    },
    /**
     * Fetch the a file
     * @param {Number|FileCard|null} file
     * @returns {FileCard}
     */
    async fetchSelectedFile(file) {
      if (!file) {
        return null;
      }
      // If the file is an id, fetch it
      if (isNumber(file) || isString(file)) {
        return api.fetch(file);
      }
      return file;
    },
    fileCreated(file) {
      this.fileSelected(file);
      this.$emit('fileCreated', this.normalizeSelectorValue(file));
    },
  },
  watch: {
    value: {
      async handler(value) {
        this.loadingStart();
        this.selectedFile = await this.fetchSelectedFile(value);
        this.loadingFinish();
      },
      immediate: true,
    },
  },
};
